<script setup lang="ts">
import type { ITableColumnsOptions } from '@modules/tables/types';
import VButton from '@components/buttons/VButton/VButton.vue';
import VIconButton from '@components/buttons/VIconButton/VIconButton.vue';
import VCard from '@components/card/VCard/VCard.vue';
import { useAffiliateChangeStatus } from '@modules/affiliates-pending/composables';
import {
  AFFILIATES_PENDING_PERMISSIONS,
  AFFILIATES_PENDING_PROFILE_ROUTE_NAME,
  TRANSLATION_GROUP_AFFILIATES_PENDING,
} from '@modules/affiliates-pending/constants';
import { useAffiliatesPendingListQuery } from '@modules/affiliates-pending/queries';
import VTable from '@modules/tables/components/VTable/VTable.vue';
import { useTableData } from '@modules/tables/composables';

const {
  tableState,
  isLoading,
  isFetching,
  data,
  updateTableState,
  refreshTableData,
} = useTableData(useAffiliatesPendingListQuery);

const columnOptions: ITableColumnsOptions = {
  email: {
    defaultMobilePreview: true,
  },
};

const { deny, approve } = useAffiliateChangeStatus();
</script>

<template>
  <VCard v-data-qa-auto-id="'AffiliatesPendingListPage'" type="table">
    <VTable
      :data="data"
      :state="tableState"
      :loading="isLoading"
      :is-fetching="isFetching"
      :title-t-path="$getTPath(TRANSLATION_GROUP_AFFILIATES_PENDING, 'HEADER')"
      :columns-options="columnOptions"
      @state-update="updateTableState"
      @refresh="refreshTableData"
    >
      <template #recordAction="{ listItem }">
        <VButton
          v-if="$hasPermission(AFFILIATES_PENDING_PERMISSIONS.REQUEST)"
          text
          :label="$getTranslation(TRANSLATION_GROUP_AFFILIATES_PENDING, 'REJECT_BTN')"
          severity="danger"
          class="min-w-0"
          @click="deny(listItem.id, $event)"
        />
        <VButton
          v-if="$hasPermission(AFFILIATES_PENDING_PERMISSIONS.REQUEST)"
          text
          :label="$getTranslation(TRANSLATION_GROUP_AFFILIATES_PENDING, 'ACCEPT_BTN')"
          severity="success"
          class="min-w-0"
          @click="approve(listItem.id, $event)"
        />
        <VIconButton
          icon="pi-id-card"
          :to="{
            name: AFFILIATES_PENDING_PROFILE_ROUTE_NAME,
            params: {
              id: listItem.id,
              tab: 'general',
            },
          }"
        />
      </template>
    </VTable>
  </VCard>
</template>
